import React, { createContext, useContext, useState, useMemo } from "react";

const initialState = {
  isDashboardDrawerOpened: false,
};

const MenuContext = createContext();

export function MenuProvider({ children }) {
  const [menuMaster, setMenuMaster] = useState(initialState);

  const handlerDrawerOpen = (isDashboardDrawerOpened) => {
    setMenuMaster((current) => ({
      ...current,
      isDashboardDrawerOpened,
    }));
  };

  const value = useMemo(
    () => ({
      menuMaster,
      menuMasterLoading: false,
      handlerDrawerOpen,
    }),
    [menuMaster]
  );

  return <MenuContext.Provider value={value}>{children}</MenuContext.Provider>;
}

export function useGetSideBarMenu() {
  return useContext(MenuContext);
}
